import { MouseEvent, useState } from 'react';
import { JobPostStatusType } from '@domain/constant/JobPostStatusType';

import classnames from 'classnames/bind';
import styles from './calendar.module.scss';
const cx = classnames.bind(styles);

interface CalendarItemProps {
  status: JobPostStatusType;
  companyName: string;
  handleEnterHover: () => void;
  handleOutHover: () => void;
  onClick: () => void;
}
const CalendarItem = ({ status, companyName, handleEnterHover, handleOutHover, onClick }: CalendarItemProps) => {
  const [visited, setVisited] = useState(false);

  const handleClick = (e: MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    setVisited(true);
    onClick();
  };

  return (
    // 캘린더 아이템 영역
    <div
      className={cx('calendarItem')}
      onMouseEnter={handleEnterHover}
      onMouseLeave={handleOutHover}
      onClick={handleClick}
    >
      {/* 기업명 영역 */}
      <div className={cx('companyArea')}>
        {/* [D] 리스트를 확인한 경우 'visited' 클래스 추가 */}
        <a className={cx('company', { visited })} role="button">
          {/* 뱃지 */}
          {/* [D] 뱃지 상태에 따라 클래스 추가 */}
          {/* [D] 끝 - end / 시 - start / 상 - always */}
          <span className={cx('badge', status)}>
            {status === 'END' ? '마감' : status === 'START' ? '시작' : '상시'}
          </span>
          {/* 기업명 */}
          <div className={cx('companyName')}>{companyName}</div>
        </a>
      </div>
    </div>
  );
};

export default CalendarItem;
